import { ListQuery } from './../utils/page-grid';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SuperAdminHttp {
  constructor(protected httpService: HttpService) {}

  listPrdSignupsForDocumentOfficer = async (listQuery) =>
    this.httpService.get(`/products/filter-signups?search=${(listQuery.searchUsers && listQuery.searchUsers) || ''}&statusList=${
      listQuery.prdStatus || ''
    }&productType=${listQuery.department || ''}&platform=${listQuery.platform}&agentId=${
      listQuery.searchAgents?.id === 'NOT_ASSIGNED' ? '' : listQuery.searchAgents?.id || ''
    }&isEmailSent=${listQuery.emailSentCustomer || false}&isKycOperatorAssigned=${listQuery.searchAgents?.id !== 'NOT_ASSIGNED'}&page=${
      listQuery.page
    }&size=${listQuery.size}
  `);

  getPrdSignup = async (prdId, userId) => this.httpService.get(`/products/${prdId}?userId=${userId}`);
  signUpactionTimeline = async (prdSignupId) => this.httpService.get(`/products/signup-action-timeline?signupId=${prdSignupId}`);

  confirmSignup = async (productSignupId, data) => this.httpService.post(`/products/complete-signup/${productSignupId}`, data);
  approveSignup = async (productSignupId, data) => this.httpService.post(`/products/approve-signup/${productSignupId}`, data);
  downloadBoSetupFile = async (productSignupId) => this.httpService.get(`/products/download-bo-setup-file?signupId=${productSignupId}`);
  downloadSignature = async (productSignupId) => this.httpService.get(`/products/download-signature-file?signupId=${productSignupId}`);
  getCompletionDetails = async (productSignupId) => this.httpService.get(`/products/completion-details/${productSignupId}`);
  checkBoidAvailabilty = (boid, userId) => this.httpService.get(`/account/check-availability?boid=${boid}&userId=${userId}`);
  roleDetails = () => this.httpService.get(`/data-adjustments/role-details`);
  getFundManagerList = async () => this.httpService.get(`/treasuries/get-fund-manager/`);
  getFundManagerbyCode = async (formData) => this.httpService.post(`/users/get-fund-manager-logins`, formData);
}

@Injectable()
export class SuperAdminService {
  emitChange$: Subject<any> = new BehaviorSubject<any>(null);
  notifiedFields$: Subject<any> = new BehaviorSubject<any>(null);
  constructor(protected http: SuperAdminHttp) {}
  emit(value: any) {
    this.emitChange$.next(value);
  }
  get emitChange(): BehaviorSubject<any> {
    return this.emitChange$ as BehaviorSubject<any>;
  }
  emitNotifiedFields(value: any) {
    this.notifiedFields$.next(value);
  }
  get notifiedFields(): BehaviorSubject<any> {
    return this.notifiedFields$ as BehaviorSubject<any>;
  }

  async listPrdSignupsForDocumentOfficer(listQuery) {
    return await this.http.listPrdSignupsForDocumentOfficer(listQuery);
  }
  async getPrdSignup(prdId, userId) {
    return await this.http.getPrdSignup(prdId, userId);
  }
  async signUpactionTimeline(prdSignupId) {
    return await this.http.signUpactionTimeline(prdSignupId);
  }
  async confirmSignup(productSignupId, data) {
    return await this.http.confirmSignup(productSignupId, data);
  }
  async approveSignup(productSignupId, data) {
    return await this.http.approveSignup(productSignupId, data);
  }
  async downloadBoSetupFile(productSignupId) {
    return await this.http.downloadBoSetupFile(productSignupId);
  }
  async downloadSignature(productSignupId) {
    return await this.http.downloadSignature(productSignupId);
  }
  async getCompletionDetails(productSignupId) {
    return await this.http.getCompletionDetails(productSignupId);
  }
  async checkBoidAvailabilty(boid, userId) {
    return await this.http.checkBoidAvailabilty(boid, userId);
  }
  async roleDetails() {
    return await this.http.roleDetails();
  }
  async getFundManagerList() {
    return await this.http.getFundManagerList();
  }
  async getFundManagerbyCode(formData) {
    return await this.http.getFundManagerbyCode(formData);
  }
}
